import * as utility from 'tyan/public'
import { getMenuByRoles, setMenus5 } from 'tyan/public/menus'
import adjustLoginInfo from 'tyan/pubConfig/adjustLoginInfo'

const loginInfo = {
	initValue: {
		token: utility.getLoginToken(),
		lock: false,
		userName: null,
		menu: null,
	},

	"Logout/SUCCESS": () => {
		utility.cleanLoginToken()
		Tyan.logoutted = true
		return { token: utility.getLoginToken() }
	},
	"GetLoginInfo/SUCCESS": (state, { receivedData: { token, roles, menu: menu5, mode = 'private', ...rest } = {} }) => {
		// console.log('menu:', menu5)
		// console.log('rest:', rest)
		if (!token && Tyan.menus.version < 5) {
			utility.cleanLoginToken()
			return { token: utility.getLoginToken() }
		}

		token && utility.setLoginToken(token)

		const menu = Tyan.menus.version < 5 ? menu5 || getMenuByRoles(roles) : setMenus5(menu5)
		const info = { token, roles, menu, mode, ...rest }
		const adjustedLoginInfo = adjustLoginInfo({ ...info }) || {}
		return {
			...state, ...info, ...adjustedLoginInfo
		}
	},

	"GetLoginInfo/FAILURE": (state, { errorMessage }) => {
		if (Object.values(Tyan.postErr)/* [Tyan.postErr['invalidToken'], Tyan.postErr['401']] */.includes(errorMessage)) {
			utility.cleanLoginToken()
			return { token: utility.getLoginToken() }
		}
		return { ...state }
	},
	"Lock/SUCCESS": (state) => {
		return { ...state, lock: true }
	},
	"Unlock/SUCCESS": (state) => {
		return { ...state, lock: false }
	},
}

loginInfo["AutoLogin/SUCCESS"] = loginInfo["GetLoginInfo/SUCCESS"]
loginInfo["Login/SUCCESS"] = loginInfo["GetLoginInfo/SUCCESS"]
loginInfo["CardLogin/SUCCESS"] = loginInfo["GetLoginInfo/SUCCESS"]
loginInfo["LoginByDingDing/SUCCESS"] = loginInfo["GetLoginInfo/SUCCESS"]
loginInfo["AuthedLogin/SUCCESS"] = loginInfo["GetLoginInfo/SUCCESS"]
loginInfo["LoginByWeiXin/SUCCESS"] = loginInfo["GetLoginInfo/SUCCESS"]

loginInfo["Logout/FAILURE"] = loginInfo["Logout/SUCCESS"]

export default loginInfo